<div
  id="user-menu"
  [class]="isMenuOpen ? 'open' : ''"
>
  <button
    type="button"
    class="trigger"
    aria-label="User menu"
    aria-haspopup="menu"
    [attr.aria-expanded]="isMenuOpen"
    (click)="onToggleMenu()"
  >
    <nsp-icon [name]="IconNames.User" />
  </button>

  <div class="dropdown">
    <div
      class="email"
      data-qa-tag="email"
    >
      {{ authStore.email() }}
    </div>

    <div class="flex items-center">
      <span class="pr-2 text-sm">Theme</span>
      <nsp-theme-selector
        [theme]="themeService.theme()"
        (themeChange)="onThemeChange($event)"
        data-testid="theme-selector"
      />
    </div>

    <button
      type="button"
      class="sign-out"
      (click)="onSignOut()"
    >
      <nsp-icon [name]="IconNames.ArrowRightFromBracket" />
      Sign Out
    </button>

    <div>
      <span class="text-xs text-gray-500">Version: {{ version }}</span>
    </div>
  </div>
</div>
